import { VAC_MARK_URL } from "@/lib/branding";

/**
 * The VAC roundel beside the "VACARS5" title, in the dispatcher dashboard's
 * brand format (mark + bold title, the 5 in red). Text, not an image, so it
 * follows the light and dark themes without a second logo file.
 */
export default function Brand({ size = "md", subtitle = "FlyVAC ACARS", testid = "app-logo" }) {
  const big = size === "lg";
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid={testid}>
      <img
        src={VAC_MARK_URL}
        alt=""
        aria-hidden="true"
        className={`${big ? "w-16 h-16" : "w-10 h-10"} shrink-0 drop-shadow-[0_6px_14px_rgba(240,20,38,0.25)]`}
      />
      <div className="grid leading-tight min-w-0">
        <strong className={`${big ? "text-4xl" : "text-lg"} font-bold tracking-tight`}>
          VACARS<span className="text-primary">5</span>
        </strong>
        {subtitle && (
          <span className={`${big ? "text-sm mt-1" : "text-xs mt-0.5"} text-muted-foreground truncate`}>{subtitle}</span>
        )}
      </div>
    </div>
  );
}
